/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest, DeepCopy } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Message from '../Common/Message/Message';
import Help from '../Common/Help/Help';
import StateOptions from '../Common/StateOptions/StateOptions';
import ProvinceOptions from '../Common/ProvinceOptions/ProvinceOptions';
import CountryOptions from '../Common/CountryOptions/CountryOptions';
import AutocompleteInput from '../Common/AutocompleteInput/AutocompleteInput';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class CreateCustomer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {
                email: undefined,
                first_name: '',
                last_name: '',
                mailing_list: true,
                email_list: true,
                shipping: 'Email',
                address_1: '',
                address_2: '',
                city: '',
                country: '',
                state: '',
                zip: '',
                phone: ''
            },
            originalCustomerEmail: '',
            hasEmailChange: false,
            validation: {
                customer: {
                    email: {
                        valid: true,
                        msg: ''
                    },
                    first_name: {
                        valid: null,
                        msg: ''
                    },
                    last_name: {
                        valid: null,
                        msg: ''
                    },
                    address_1: {
                        valid: null,
                        msg: ''
                    },
                    city: {
                        valid: null,
                        msg: ''
                    },
                    state: {
                        valid: true,
                        msg: ''
                    },
                    country: {
                        valid: true,
                        msg: ''
                    },
                    zip: {
                        valid: null,
                        msg: ''
                    },
                    phone: {
                        valid: true,
                        msg: ''
                    }
                }
            },
            physicalMailingValidationObject: {
                address_1: {
                    value: '',
                    key: 'customer',
                    name: 'address_1',
                    validationRegEx: '(^(?!\\s*$).+)'
                },
                city: {
                    value: '',
                    key: 'customer',
                    name: 'city',
                    validationRegEx: '(^(?!\\s*$).+)'
                },
                zip: {
                    value: '',
                    key: 'customer',
                    name: 'zip',
                    validationRegEx: '(^\\d{5}(-\\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\\d{1}[A-Za-z]{1} *\\d{1}[A-Za-z]{1}\\d{1}$)'
                }
            },
            isCustomerEditingMode: false,
            isReadyToSubmit: false,
            message: {
                title: '',
                content: '',
                type: ''
            }
        };
    }

    getActiveCustomer = (customer_id) => {
        this.setMessage('','','loading');
        (async () => {
            try {
                let response = await getCustomer(this.state.customer);
                console.log('Get Customer: ', response);
                if(response.data.customer){
                    let customerUpdate = response.data.customer;
                    if(customerUpdate.country === ""){
                        customerUpdate.country = "";
                    }
                    console.log(customerUpdate.email)
                    this.setState({ 
                        originalCustomerEmail: customerUpdate.email,
                        customer:customerUpdate,
                        isReadyToSubmit: true,
                        isCustomerEditingMode: true
                    }, () => this.setMessage('', '', ''));

                    const validation = {...this.state.validation};
                    for (let type in validation) {
                        validation[type]['valid'] = true;
                    }
                    this.setState({validation});
                } else {
                    this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCustomer(data) {
            return await ApiRequest(`/customers/${customer_id}`, {
                method: 'GET'
            });
        }
    }

    handleCustomerAddress = (value) => {
        const customer = { ...this.state.customer };
        customer.address_1 = value;
        this.setState({ 
            customer,
        });
    }

    handleFullCustomerAddress = (value) => {
        console.log(value);
    }

    handleChange = (e) => {
        e.persist();
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        const customer = { ...this.state.customer };
        let hasEmailChange = this.state.hasEmailChange;
        let originalCustomerEmail = this.state.originalCustomerEmail;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        customer[name] = value;
        if (name === 'email') {
            hasEmailChange  = customer.email !== originalCustomerEmail;
            console.log('customer.email', customer.email)
            console.log('originalCustomerEmail', originalCustomerEmail)
            console.log('hasEmailChange', hasEmailChange)
            if (originalCustomerEmail === '') {
                originalCustomerEmail = value;
            }
        }
        this.setState({ 
            customer,
            originalCustomerEmail,
            hasEmailChange,
        });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
    }

    validateRequiredField = (e) => {
        const validation = { ...this.state.validation };
        if (e !== null && e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;     
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => { 
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => { 
            return i.filter((l) => { 
                return typeof(l.valid) !== 'undefined'; 
            }).length; 
        })
        .reduce(this.getSum);
        
        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    validate = (value, key, name, validationRegEx, e=null) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[key][name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        if(value === '') {
            validation[key][name]['msg'] = strings.errorRequired;
            isValid = false;
        }
        validation[key][name]['valid'] = isValid; 
        
        if(name === 'email' && value === ''){
            validation[key][name]['valid'] = true; 
        }
        if(name === 'phone' && value === ''){
            validation[key][name]['valid'] = true; 
        }
        this.setState({ validation }, () => {this.validateRequiredField(e)});
    }

    validateAllFields = () => {
        var inputs = [].slice.call(document.querySelectorAll("[validation]"));
        inputs.forEach((input) => {
            if (typeof input !== 'undefined' && input.name !== 'phone') {
                this.validate(input.value, input.attributes.getNamedItem('object').value, input.name, input.attributes.getNamedItem('validation').value)
            }
        });
    }

    validatePhysicalMailing = (bool, e=null) => {
        e !== null && e.persist();
        const physicalMailingValidationObject = { ...this.state.physicalMailingValidationObject };
        for (let key in physicalMailingValidationObject) {
            physicalMailingValidationObject[key]['value'] = this.state.customer[key];
        }
        if (bool) {
            for (let key in physicalMailingValidationObject) {
                this.validate(
                    physicalMailingValidationObject[key]['value'],
                    physicalMailingValidationObject[key]['key'],
                    physicalMailingValidationObject[key]['name'],
                    physicalMailingValidationObject[key]['validationRegEx'],
                    e
                );
            }
        } else {
            this.invalidatePhysicalMailing(Object.keys(physicalMailingValidationObject));
        }
    }

    invalidatePhysicalMailing = (inputs) => {
        const validation = { ...this.state.validation }
        inputs.forEach((input) => {
            if (validation['customer'].hasOwnProperty(input)) {
                validation['customer'][input]['valid'] = true;
            }
        })
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    save = async () => {
        const customerId = this.state.isCustomerEditingMode ? this.state.customer.id : '';
        const method = this.state.isCustomerEditingMode ? 'put' : 'post';
        const string = this.state.isCustomerEditingMode ? strings.msg.updated : strings.msg.added;
        this.setMessage('','','loading');

        try {
            // First check if email address is already linked to a customer
            let responseCheck = await checkIfEmailExist(this.state.customer);
            console.log('Does email already exist:', responseCheck);

            if (this.state.hasEmailChange) {
                if(responseCheck.data.exists){
                    this.setMessage(window.general_strings.msg.oops,strings.msg.userExist,'error');
                } else {
                    let response = await addCustomer(this.state.customer, customerId, method);
                    console.log('Add Customer: ', response);
                    if(response.data.customer || response.data.success){
                        this.setMessage(window.general_strings.msg.yay,strings.msg.success,'success');
                        if(typeof response.data.customer !== 'undefined'){
                            this.props.routeProps.history.push('/create-customer/' + response.data.customer.id);
                            this.getActiveCustomer(response.data.customer.id);
                        }
                    } else {
                        this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                    }
                }
            } else {
                let response = await addCustomer(this.state.customer, customerId, method);
                console.log('Add Customer: ', response);
                if(response.data.customer || response.data.success){
                    this.setMessage(window.general_strings.msg.yay,strings.msg.success,'success');
                    if(typeof response.data.customer !== 'undefined'){
                        this.props.routeProps.history.push('/create-customer/' + response.data.customer.id);
                        this.getActiveCustomer(response.data.customer.id);
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops,response.data.error.code,'error');
                }
            }
            
        } catch (error) {
            console.log(error);
        }

        async function checkIfEmailExist(data) {
            return await ApiRequest(`/customers/check-email`, {
                method: 'post',
                data: {
                    email: data.email
                }
            });
        }

        async function addCustomer(data, customerId, method) {
            return await ApiRequest(`/customers/${customerId}`, {
                method,
                data: {
                    email: data.email || undefined,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    address_1: data.address_1,
                    address_2: data.address_2,
                    city: data.city,
                    state: data.state,
                    zip: data.zip,
                    country: data.country,
                    mailing_list: data.mailing_list,
                    email_list: data.email_list,
                    phone: data.phone
                }
            });
        }
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    getActiveCustomer = async (customer_id) => {
        this.setMessage('', '', 'loading');
        try {
            let response = await getCustomer(this.state.customer);
            console.log('Get Customer: ', response);
            if (response.data.customer) {
                this.setState({
                    originalCustomerEmail: response.data.customer.email,
                    customer: response.data.customer,
                    isCustomerEditingMode: true
                }, () => {
                    this.validateAllFields();
                    this.validatePhysicalMailing(this.state.customer.mailing_list);
                    this.setMessage('', '', '');
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
            }
        } catch (error) {
            console.log(error);
        }

        async function getCustomer(data) {
            return await ApiRequest(`/customers/${customer_id}`, {
                method: 'GET'
            });
        }
    }

    updateCustomerFromAutocompleteInput = (customer, validation) => {
        this.setState({
            customer,
            validation
        }, () => this.validateAllRequiredFields());
    }

    componentDidMount() {
        this.baseCustomer = DeepCopy(this.state.customer);
        this.baseValidation = DeepCopy(this.state.validation);
        const params = this.props.routeProps.match.params;
        if (params && params.id) {
            this.getActiveCustomer(params.id);
        }
    }

    render() {
        return (
            <div className="showtix-section container">
                <div className="row">
                    <div className="col-12">
                        <h1>
                            {this.state.isCustomerEditingMode === false ? strings.newCustomer : strings.existingCustomer}
                        </h1>
                    </div>
                </div>

                <Message
                    message={this.state.message}
                />

                <div className="row">    
                    <div className="col-12 col-lg-8">
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="customer_firstName">{strings.firstName}*</label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            id="customer_firstName"
                                            object="customer"
                                            name="first_name"
                                            value={this.state.customer.first_name}
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            validation="(^(?!\s*$).+)"
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.customer.first_name.valid &&
                                        <div className=" showtix-note error">
                                        {this.state.validation.customer.first_name.msg}
                                        </div>
                                    }
                                </div> 
                            </div>     

                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="customer_lastName">{strings.lastName}*</label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            id="customer_lastName"
                                            object="customer"
                                            name="last_name"
                                            value={this.state.customer.last_name}
                                            onChange={this.handleChange}
                                            onBlur={this.validateRequiredField}
                                            validation="(^(?!\s*$).+)"
                                            required
                                        />
                                    </div>
                                    {!this.state.validation.customer.last_name.valid &&
                                        <div className=" showtix-note error">
                                        {this.state.validation.customer.last_name.msg}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className={"showtix-form__group " + (this.state.validation.customer.email.valid === false ? 'showtix-form__error' : '')}>
                                    <label className="showtix-label" htmlFor="customer_email">{strings.email}</label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            id="customer_email"
                                            object="customer"
                                            name="email"
                                            value={this.state.customer.email}
                                            validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    {!this.state.validation.customer.email.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.customer.email.msg}
                                        </div>
                                    }
                                </div>
                            </div>   
                            <div className="col-12 col-md-6">
                                <div className={"showtix-form__group " + (this.state.validation.customer.phone.valid === false && this.state.customer.phone !== '' ? 'showtix-form__error' : '')}>
                                    <label className="showtix-label" htmlFor="customer-phone">{strings.phone}</label>
                                    <div className="showtix-form__input">
                                        <input
                                            type="text"
                                            className="showtix-input"
                                            id="customer-phone"
                                            object="customer"
                                            name="phone"
                                            value={this.state.customer.phone}
                                            validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                    {!this.state.validation.customer.phone.valid &&
                                        <div className=" showtix-note error">
                                            {this.state.validation.customer.phone.msg}
                                        </div>
                                    }
                                </div>
                            </div> 
                        </div>


                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.physicalMailing}</label>

                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="physical-1"
                                                    object="customer"
                                                    name="mailing_list"
                                                    value="true"
                                                    checked={this.state.customer.mailing_list === true}
                                                    onChange={(e) => {
                                                        this.validatePhysicalMailing(true, e);
                                                        this.handleChange(e);
                                                    }}
                                                />
                                                <label className="showtix-label" htmlFor="physical-1">{strings.yes}</label>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="physical-2"
                                                    object="customer"
                                                    name="mailing_list"
                                                    value="false"
                                                    checked={this.state.customer.mailing_list === false}
                                                    onChange={(e) => {
                                                        this.validatePhysicalMailing(false, e);
                                                        this.handleChange(e);
                                                    }}
                                                /> <label className="showtix-label" htmlFor="physical-2">{strings.no}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.emailList}</label>

                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="email-1"
                                                    object="customer"
                                                    name="email_list"
                                                    value="true"
                                                    checked={this.state.customer.email_list === true}
                                                    onChange={this.handleChange}
                                                />
                                                <label className="showtix-label" htmlFor="email-1">{strings.yes}</label>
                                            </div>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <div className="showtix-form__radio">
                                                <input
                                                    type="radio"
                                                    className="showtix-input"
                                                    id="email-2"
                                                    object="customer"
                                                    name="email_list"
                                                    value="false"
                                                    checked={this.state.customer.email_list === false}
                                                    onChange={this.handleChange}
                                                /> 
                                                <label className="showtix-label" htmlFor="email-2">{strings.no}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>    

                        {this.state.customer.mailing_list === true &&                       
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className={"showtix-form__group " + (this.state.validation.customer.address_1.valid === false && this.state.customer.address_1 !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="address-1">{strings.address1}*</label>
                                        <div className="showtix-form__input">
                                            <AutocompleteInput
                                                validateRequiredField={this.validateRequiredField}
                                                handleCustomerInformation={this.handleChange}
                                                handleCustomerAddress={this.handleCustomerAddress}
                                                handleFullCustomerAddress={this.handleFullCustomerAddress}
                                                updateCustomerFromAutocompleteInput={this.updateCustomerFromAutocompleteInput}
                                                {...this.state} />
                                        </div>
                                        {!this.state.validation.customer.address_1.valid &&
                                            <div className=" showtix-note error">
                                                {this.state.validation.customer.address_1.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="customer-address-2">{strings.address2}</label>
                                        <div className="showtix-form__input">
                                            <input 
                                                id="customer-address-2"
                                                className="showtix-input" 
                                                type="text" 
                                                object="customer" 
                                                name="address_2" 
                                                value={this.state.customer.address_2}
                                                onChange={this.handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className={"showtix-form__group " + (this.state.validation.customer.city.valid === false && this.state.customer.city !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="customer-city">{strings.city}*</label>
                                        <div className="showtix-form__input">
                                            <input 
                                                id="customer-city"
                                                className="showtix-input" 
                                                type="text" 
                                                object="customer" 
                                                name="city" 
                                                validation="(^(?!\s*$).+)"
                                                value={this.state.customer.city}
                                                onBlur={this.validateRequiredField}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </div>
                                        {!this.state.validation.customer.city.valid &&
                                            <div className=" showtix-note error">
                                                {this.state.validation.customer.city.msg}
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="customer-country">{strings.country}*</label>
                                        <div className="showtix-form__select">
                                            <select className="showtix-input"
                                                object="customer"
                                                name="country"
                                                id="customer-country"
                                                value={this.state.customer.country}
                                                onChange={this.handleChange}
                                                required
                                            >
                                                <option value="">{strings.selectCountry}</option>
                                                <CountryOptions />
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="showtix-form__group">
                                        <label className="showtix-label" htmlFor="customer-state">{strings.state}*</label>
                                        <div className="showtix-form__select">
                                            {this.state.customer.country === "US" || this.state.customer.country === ""  ?
                                                <select className="showtix-input"
                                                    object="customer"
                                                    name="state"
                                                    id="customer-state"
                                                    value={this.state.customer.state}
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">{strings.selectState}</option>
                                                    <StateOptions />
                                                </select>
                                                :
                                                <select 
                                                    className="showtix-input" 
                                                    object="customer" 
                                                    name="state" 
                                                    value={this.state.customer.state}
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">{strings.selectState}</option>
                                                    <ProvinceOptions />
                                                </select>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className={"showtix-form__group " + (this.state.validation.customer.zip.valid === false && this.state.customer.zip !== '' ? 'showtix-form__error' : '')}>
                                        <label className="showtix-label" htmlFor="customer-zip">{strings.zip}*</label>
                                        <div className="showtix-form__input">
                                            <input
                                                id="customer-zip"
                                                type="text"
                                                className="showtix-input"
                                                object="customer"
                                                name="zip"
                                                value={this.state.customer.zip}
                                                validation="(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)"
                                                onChange={this.handleChange}
                                                onBlur={this.validateRequiredField}
                                                required
                                            />
                                        </div>
                                        {!this.state.validation.customer.zip.valid &&
                                            <div className=" showtix-note error">
                                                {this.state.validation.customer.zip.msg}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="row">
                            <div className="col-12">
                                <button 
                                    type="button"
                                    className="showtix-button showtix-background__primary-2"
                                    onClick={this.save}   
                                    disabled={!this.state.isReadyToSubmit} 
                                >
                                    <span>{this.state.isCustomerEditingMode === false ? strings.save : strings.update}</span>
                                </button> 
                            </div>
                        </div>  
                    </div>

                    { strings.help &&
                    <div className="col-12 col-lg-4">
                        <Help help={strings.help} />
                    </div>
                    }
                </div>                         
            </div>
        );
    }
}

CreateCustomer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.object
    }).isRequired
}

export default CreateCustomer;


// WEBPACK FOOTER //
// ./src/components/CreateCustomer/CreateCustomer.js